import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { COLORS_SCALE_WIDTH } from '@/constants';
import { formatCurrency } from '@/helpers/format/formatCurrency';
import { useMapContext } from '@/hooks/useMapContext/useMapContext';
export const MapLegend = () => {
    const { mapLegendData: data } = useMapContext();
    const { language } = useLocale();
    if (!data) {
        return null;
    }
    const colorScaleWidth = data.colorScaleLevels.length > 0 ? COLORS_SCALE_WIDTH / data.colorScaleLevels.length : 0;
    const minPrice = data.colorScaleLevels.length > 0 ? data?.colorScalePriceRanges[0][1] : null;
    const maxPrice = data.colorScaleLevels.length > 0
        ? data?.colorScalePriceRanges[data.colorScalePriceRanges.length - 1][0]
        : null;
    return (_jsxs(Box, { display: "flex", alignContent: "stretch", alignItems: "center", justifyContent: "center", width: "100%", children: [_jsx(Box, { textAlign: "right", paddingLeft: "0", paddingRight: "spacing.8", whiteSpace: "nowrap", typography: "typography.body.14.regular", children: typeof minPrice === 'number' ? `< ${formatCurrency(minPrice, language)}` : '-' }), _jsx(Box, { borderRadius: "radius.rounded", overflow: "hidden", display: "flex", alignContent: "stretch", alignItems: "center", justifyContent: "center", children: data.colorScaleLevels.map((legend, index) => (
                // TODO: REFACTOR WITH BOX COMPONENT WHEN COLORSCALE IS DEFINED IN THE DESIGN SYSTEM
                _jsx("div", { style: {
                        width: `${colorScaleWidth}px`,
                        height: '8px',
                        backgroundColor: legend,
                    } }, index))) }), _jsx(Box, { textAlign: "left", paddingLeft: "spacing.8", paddingRight: "0", whiteSpace: "nowrap", typography: "typography.body.14.regular", children: typeof maxPrice === 'number' ? `> ${formatCurrency(maxPrice, language)}` : '-' })] }));
};
